import React from 'react';
import { end } from '@atlassian/servicedesk-frontend-apdex';
import ReadyForUser from './view';

export type Props = {
	baseUrl: string;
	context?: string | undefined;
};

/**
 * This component should be rendered once a page is deemed ready for user interaction. The APDEX
 * event to end will be determined from the current route.
 *
 * The baseUrl prop is required to determine the page location (without baseUrl).
 *
 * This will end the currently running performance metrics (i.e., for APDEX).
 * Each page (route) should mount this component once.
 *
 * If a page will need to fire multiple APDEX events over its lifetime, the
 * "context" prop should be passed and should change with each event which is
 * relevant for APDEX.
 *
 * This component should be rendered into the DOM only once, as the first child and as high-up in
 * the tree as possible, AFTER any required rendering has completed. It should be placed so that
 * #componentDidMount of this component (which captures the timing) is called as early as possible
 * after the DOM is ready-for-user (before all other #componentDidMount calls of child components).
 *
 * Side note: interestingly, if you have 2 nested components like <A><B/></A>, React will call
 * #componentDidMount of <B> first (from testing on React 15/16), however this should not be a
 * problem, provided that this is rendered as one of the first children and since this component
 * will be a leaf.
 *
 * From measurements on a local dev machine, the time between the DOM being rendered and the
 * ready-for-user checkpoint is only a few milliseconds at most.
 */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => <ReadyForUser {...props} onLoadEnd={end} />;
